module.exports = __webpack_public_path__ + "img/card-b-bright.b1ef1bdb.png";